<template>
    <div id="boxberry-widget">
        <div id="boxberry_map" style="height: 73vh"></div>
    </div>
</template>
<script src="./pickup-point-picker.js"  />
